import _defineProperty from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import _objectWithoutProperties from "/vercel/path0/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["onChange", "rules", "id", "required", "control", "type", "rows", "maxLength", "testId", "twStyle", "showMaxLength", "isError"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import _styled from "styled-components";
import * as React from 'react';
import { Controller } from 'react-hook-form';
import { Textarea as FlowBiteTextarea } from 'flowbite-react';
import Title from '../title';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TextArea = function TextArea(props) {
  var _onChange = props.onChange,
      _props$rules = props.rules,
      rules = _props$rules === void 0 ? {} : _props$rules,
      id = props.id,
      required = props.required,
      control = props.control,
      type = props.type,
      _props$rows = props.rows,
      rows = _props$rows === void 0 ? 4 : _props$rows,
      maxLength = props.maxLength,
      testId = props.testId,
      twStyle = props.twStyle,
      _props$showMaxLength = props.showMaxLength,
      showMaxLength = _props$showMaxLength === void 0 ? true : _props$showMaxLength,
      isError = props.isError,
      rest = _objectWithoutProperties(props, _excluded);

  var _React$useState = React.useState(),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      remainingChars = _React$useState2[0],
      setRemainingChars = _React$useState2[1];

  var handleOnChange = React.useCallback(function (event) {
    if (!maxLength) return;
    var newRemainingChars = maxLength - event.target.value.length;
    setRemainingChars(newRemainingChars);
    return newRemainingChars;
  }, [maxLength]);
  return control ? /*#__PURE__*/_jsx(Controller, {
    name: id,
    control: control,
    rules: rules,
    render: function render(_ref) {
      var field = _ref.field;
      return /*#__PURE__*/_jsx(TextAreaStyled, _objectSpread(_objectSpread(_objectSpread({}, field), rest), {}, {
        maxLength: maxLength,
        onChange: function onChange(evt) {
          handleOnChange(evt);
          field.onChange(evt);
        },
        "data-cy": testId,
        twStyle: twStyle
      }));
    }
  }) : /*#__PURE__*/_jsxs(_StyledDiv, {
    children: [/*#__PURE__*/_jsx(TextAreaStyled, _objectSpread(_objectSpread({
      id: id,
      rows: rows
    }, rest), {}, {
      maxLength: maxLength,
      onChange: function onChange(evt) {
        handleOnChange(evt);
        if (_onChange) _onChange(evt.target.value);
      },
      "data-cy": testId,
      twStyle: twStyle,
      isError: isError
    })), maxLength && showMaxLength ? /*#__PURE__*/_jsx(Title, {
      content: "".concat(remainingChars || maxLength, "/").concat(maxLength),
      fontWeight: "normal",
      textColor: "gray",
      fontSize: "xSmall",
      twStyle: {
        "position": "absolute",
        "right": "1rem",
        "bottom": "0.5rem"
      }
    }) : null]
  });
};
export default TextArea;

var TextAreaStyled = /*#__PURE__*/_styled(FlowBiteTextarea).withConfig({
  displayName: "formtextarea__TextAreaStyled",
  componentId: "sc-53i327-0"
})(["", " ", " ", " ", ""], {
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))"
}, {
  "borderRadius": "0.5rem",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(212 193 245 / var(--tw-border-opacity))",
  ":focus": {
    "--tw-border-opacity": "1 !important",
    "borderColor": "rgb(196 177 231 / var(--tw-border-opacity)) !important",
    "--tw-ring-opacity": "1 !important",
    "--tw-ring-color": "rgb(196 177 231 / var(--tw-ring-opacity)) !important"
  }
}, function (_ref2) {
  var color = _ref2.color,
      isError = _ref2.isError;
  return color === 'failure' || isError ? {
    "--tw-border-opacity": "1",
    "borderColor": "rgb(204 0 34 / var(--tw-border-opacity))",
    "--tw-bg-opacity": "1",
    "backgroundColor": "rgb(250 230 233 / var(--tw-bg-opacity))"
  } : {};
}, function (_ref3) {
  var twStyle = _ref3.twStyle;
  return twStyle ? twStyle : {};
});

var _StyledDiv = /*#__PURE__*/_styled("div").withConfig({
  displayName: "formtextarea___StyledDiv",
  componentId: "sc-53i327-1"
})({
  "position": "relative"
});